import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <img 
              src="/images/ailen.png" 
              alt="Ailen smiling" 
              className="img-fluid rounded hero-image"
            />
          </div>
          <div className="col-md-6">
            <h1 className="hero-title">
              Clases de inglés que te ayudarán a expresarte con seguridad en cualquier entorno
            </h1>
            <a href="/get-started" className="btn btn-primary hero-btn">
              Empieza ahora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
